export default __webpack_public_path__ + "static/media/elogio-img.9c6c5af0.png";